module.exports = __webpack_public_path__ + "static/img/plat.ae1b408.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard/league-ad-section/plat.png
// module id = NjT+
// module chunks = 35